// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1359":"0bf1b6d6403ca20a8e30","8618":"1e8f15db3b14455fef8f"}[chunkId] + "";
};